import { styled, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

const LocalTestField = styled(TextField)(() => ({
  width: '100%',
}));

type ControllerFieldProps = Parameters<GetComponentProps<typeof Controller>['render']>[0]['field'];

export const TextArea = React.forwardRef<any, TextFieldProps & Optional<ControllerFieldProps, 'ref'>>(props => {
  return (
    <LocalTestField
      multiline
      sx={{ '& div': { padding: '0', /* overflow: 'auto', */ height: 'auto' } }}
      InputProps={{
        sx: { textarea: { padding: '12px' } },
      }}
      {...props}
      FormHelperTextProps={{ sx: { margin: '3px 0 0 0' } }}
    />
  );
});

TextArea.displayName = 'TextArea';
